import styled from '../../utils/styled';
import { mediaBreakpointDownMD } from '../../../constants/style-constants';

const getColor = (primaryColor, item) => {
  if (primaryColor && item.textColor === 'primary') {
    return primaryColor;
  }
  if (item.textColor) {
    return item.textColor;
  }
  return '#fff';
};

const getBorders = (isTopRight, alternate) => {
  if (alternate) return { border: 'none' };

  return { borderTop: isTopRight ? '1px solid #343434' : 'none' };
};

export const NavigationItemContainer = styled.div(
  {
    width: '100%',
    textTransform: 'uppercase',
  },
  ({ isTopRight, fontSize, alternate }) => ({
    padding: isTopRight ? '20px 10px' : '20px 30px',
    display: 'flex',
    fontSize: fontSize || (isTopRight ? '18px' : '25px'),
    ...getBorders(isTopRight, alternate),
  }),
);

export const Item = styled.div(
  {
    fontFamily: 'Spyscapetwo webfont, sans-serif',
    fontWeight: '300',
    display: 'flex',
    alignItems: 'center',
    [mediaBreakpointDownMD]: {
      fontSize: '14px',
    },
  },
  ({ isReturn }) => ({
    fontWeight: isReturn ? '500' : '300',
  }),
);

export const ArrowLeft = styled.img({
  minWidth: '16px',
  maxHeight: '16px',
  marginRight: '10px',
});

export const NavigationItemLink = styled.div(({ item, primaryColor, alternate }) => ({
  width: '100%',
  color: alternate ? '#002266' : getColor(primaryColor, item, alternate),
  '&:hover': {
    color: alternate ? 'rgb(78, 206, 247)' : getColor(primaryColor, item, alternate),
  },
}));

export const IconImage = styled.img({
  marginRight: '10px',
  minWidth: '16px',
});

export const ArrowRight = styled.img({
  marginLeft: 'auto',
});
